import { render, staticRenderFns } from "./Icookin.vue?vue&type=template&id=75970634&scoped=true"
import script from "./Icookin.vue?vue&type=script&lang=js"
export * from "./Icookin.vue?vue&type=script&lang=js"
import style0 from "./Icookin.vue?vue&type=style&index=0&id=75970634&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75970634",
  null
  
)

export default component.exports